import React, { useState } from 'react';
import {
  Paper,
  Chip,
  ButtonGroup,
  Button,
} from '@mui/material';
import notify from 'devextreme/ui/notify';
import {
  Link as RouterLink,
  MemoryRouter,
} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Link, Navigate, useParams } from "react-router-dom";
import Form, { 
  EmptyItem, 
  GroupItem, 
  Label, 
  SimpleItem,
  CompareRule,
  EmailRule,
  PatternRule,
  RangeRule,
  RequiredRule,
  StringLengthRule,
} from 'devextreme-react/form';
import 'devextreme-react/text-area';
import 'devextreme-react/select-box';

import moment from 'moment';

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import TextBox from 'devextreme-react/text-box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import ServiceUserForm, { NotActivatedString } from './ServiceUserForm';

// ************************************************************
// ************************************************************
// ************************************************************

export const ServiceUserDetailsComponentWrapper = (props) => {
  const { user_id } = useParams()
  const navigate = useNavigate()
  return <ServiceUserDetails user_id={user_id} navigate={navigate} {...props} />
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  
  // https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}
function a11yProps(index) { return { id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}` } }
function notifySomething(message, type="success") {
  notify({
    message: message,
    position: {
      my: 'center top',
      at: 'center top',
    },
  }, type, 3000)
}
class ServiceUserDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: undefined,
      tempUser: undefined,
      loading: true,
      readOnly: true,
      userIdLoaded: -1,
      selectedTabIndex: 0,
    }    
  }
  componentDidMount() {
    console.log("MOUNT: this.props.user_id", this.props.user_id)    
    if (this.props.authStatus && this.props.authStatus.completed)
      this.loadUser(this.props.user_id)    
  }  
  componentDidUpdate(prevProps) {
    console.log("UPDATE: this.props.user_id", this.props.user_id)
    if (this.props.authStatus && this.props.authStatus.completed)
      this.loadUser(this.props.user_id)
  }  
  async loadUser(user_id) {
    if (user_id === this.state.userIdLoaded) return

    await this.setState({ 
      user: undefined,
      loading: true,      
      readOnly: true,
      userIdLoaded: user_id,
    })     
     
    console.log("loading user", user_id)

    try {
      var data = await AuthService.getServiceUserDetails(user_id)
      if (data.is_valid) {
        console.log("loading done")
        var d = moment(data.user.created_at)
        data.user.registration_date = d.isValid() ? d.format("DD/MM/YYYY HH:mm") : "undefined";        
        d = moment(data.user.activated_at)
        data.user.activation_date = d.isValid() ? d.format("DD/MM/YYYY HH:mm") : NotActivatedString;
        await this.setState({ user: { ...data.user } })        
      } else {
        console.log(data.message)
        notifySomething(data.message, "error")
      }      
    } catch (e) {
      console.log(e)
      notifySomething(e, "error")      
    }
    this.setState({ 
      loading: false,        
      readOnly: true,
    })
  }  
  async updateUser() {
    var user_data = { ...this.state.user }      
    await this.setState({ 
      loading: true,
      readOnly: true,
    })
    try {
      var data = await AuthService.setServiceUserDetails(user_data)
      if (data.is_valid) {
        notifySomething("DATA SAVED")
      } else {
        console.log(data.message)  
        notifySomething(data.message, "error")
      }
    } catch(e) {
      console.log(e)
      notifySomething(e, "error")
    }
    await this.setState({ 
      loading: false,
      readOnly: false,
      userIdLoaded: undefined,
    })
  }  
  async editUser_btn_force_activation_click() {
    if (!window.confirm("Are you sure?")) return
    await this.setState({ 
      loading: true,
      readOnly: true,
    })
    try {
      var data = await AuthService.forceServiceUserActivation(this.state.user.id)
      if (data.is_valid) {
        notifySomething("USER ACTIVATED")
      } else {
        console.log(data.message)
        notifySomething(data.message, "error")
      }      
    } catch (e) {
      console.log(e)
      notifySomething("Unknown error", "error")      
    }

    await this.setState({ 
      loading: false,
      userIdLoaded: undefined,
    })
  }
  editUser_btn_edit_click() {
    this.setState({      
      readOnly: false,
      tempUser: { ...this.state.user },
    })
  }
  editUser_btn_cancel_click() { 
    this.setState({      
      readOnly: true,
      user: { ...this.state.tempUser },
    })
  }
  editUser_btn_submit_click() { this.updateUser() }
  // funzione per visualizzare un messaggio che poi scompare in automatico
  
  render() {     
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />

    if (this.props.authStatus.user.is_admin) {
      // ok      
    } else if (this.props.authStatus.user.is_reseller) {
      // ok      
    } else if (this.props.authStatus.user.id === parseInt(this.props.user_id)) {
      // utente normale che visualizza se stesso
    } else {
      return <UserAuthRequired notallowed />
    }
    
    if (this.state.loading) return <LoadingSpinner />
    
    // ***
    
    var disable_connected_computers = true
    if (this.state.user.is_reseller)
      if (this.props.authStatus.user.is_admin || this.props.authStatus.user.is_reseller) 
        disable_connected_computers = false
    
    var computers_list_url = "/computer/list"
    if (this.props.authStatus.user.is_admin || this.props.authStatus.user.is_reseller) 
      computers_list_url = "/computer/list/user/"+this.state.user.id
    
    var disable_unlocked = true
    if (this.state.user.accesso_keygen && this.props.authStatus.user.is_admin) 
      disable_unlocked = false
    else if (this.state.user.accesso_keygen && this.props.authStatus.user.id === this.state.user.id)
      disable_unlocked = false

    var unlocked_url = "/service/unlock/code/list"
    if (this.props.authStatus.user.is_admin) 
      unlocked_url = "/service/unlock/code/list/"+this.state.user.id

    // ***

    let tabIndex = 0;
    const tabs = [
      <Tab key="username" label={this.state.user.username} {...a11yProps(tabIndex++)} />,
      <Tab key="owned-computers" label="Owned computers" {...a11yProps(tabIndex++)} />,
      !disable_connected_computers && <Tab key="connected-computers" label="Connected computers" {...a11yProps(tabIndex++)} />,
      !disable_unlocked && <Tab key="unlock-codes" label="Unlock codes" {...a11yProps(tabIndex++)} />
    ].filter(Boolean);

    tabIndex = 0;
    const tabPanels = [
      <TabPanel key="tabpanel-username" value={this.state.selectedTabIndex} index={tabIndex++}>
        <ServiceUserForm 
          btn_force_activation_click={this.editUser_btn_force_activation_click.bind(this)}
          btn_edit_click={this.editUser_btn_edit_click.bind(this)}
          btn_cancel_click={this.editUser_btn_cancel_click.bind(this)}
          btn_submit_click={this.editUser_btn_submit_click.bind(this)}
          newUser={false}
          isAdmin={this.props.authStatus.user.is_admin}
          isReseller={this.props.authStatus.user.is_reseller}
          readOnly={this.state.readOnly}
          user={this.state.user}
          hideAgrees={true}                  
        />
      </TabPanel>,
      <TabPanel key="tabpanel-owned-computers" value={this.state.selectedTabIndex} index={tabIndex++}>
        <Navigate to={computers_list_url} replace={true} />
      </TabPanel>,
      !disable_connected_computers && <TabPanel key="tabpanel-connected-computers" value={this.state.selectedTabIndex} index={tabIndex++}>
        <Navigate to={"/computer/list/reseller/"+this.state.user.id} replace={true} />
      </TabPanel>,
      !disable_unlocked && <TabPanel key="tabpanel-unlock-codes" value={this.state.selectedTabIndex} index={tabIndex++}>
        <Navigate to={unlocked_url} replace={true} />
      </TabPanel>
    ].filter(Boolean);

    return (
      <>
        <div>
          <div className="container-sm">
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs 
                  value={this.state.selectedTabIndex}
                  onChange={(e, newValue) => {
                    this.setState({
                      selectedTabIndex: newValue,
                    })                    
                  }} 
                  aria-label="tabs">
                  {tabs}
                </Tabs>
              </Box>
              {tabPanels}
            </Box>
          </div>
        </div>      
      </>
    )
  }
}
